module.exports = __webpack_public_path__ + "media/images/contacts-map-02-aaba639a2c5a1fd6edec5f85bbb56e72.svg";